import { useMemo } from "react";
import {
  groupDataByField,
  groupDataByDualFields,
} from "@/lib/utils/crm/grouping-strategies";
import { BaseEntity, SimpleTableConfig } from "../../UniversalCRMTable/types/shared";

/**
 * Hook to handle data grouping logic
 * Supports single and dual-field grouping
 */
export function useDataGrouping<T extends BaseEntity>(
  data: T[],
  groupByField: string | null,
  secondaryGroupByField: string | null | undefined,
  config: SimpleTableConfig<T>
) {
  const groupedData = useMemo(() => {
    if (!groupByField) return data;

    if (secondaryGroupByField) {
      return groupDataByDualFields(data, groupByField, secondaryGroupByField, config);
    }

    return groupDataByField(data, groupByField, config);
  }, [data, groupByField, secondaryGroupByField, config]);

  return { groupedData };
}

// Made with Bob
